import { NotificationServiceBus } from './../../notification/notification.service';
import { SpinnerService } from './../../spinner/spinner.service';
import { BookingService } from './../../api/booking.service';
import { PopupComponent } from './../../shared/popup/popup.component';
import { MdDialog } from '@angular/material';
import { BookingListMultiSelectService } from './booking-list-multi-select.service';
import { Component, Input, Output, OnInit, EventEmitter, OnChanges, ViewContainerRef } from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {Booking} from '../../shared/model/booking.entity';
import {Router} from '@angular/router';
import {BOOKING_STATE} from '../../shared/model/booking-state.enum';
import {BOOKING_STATUS} from '../../shared/model/booking-status.enum';
import {GLOBAL} from '../../shared/global';
import {
    Administrator,
    BookingOfficer,
    IndividualClient,
    Interpreter,
    OrganisationalRepresentative
} from '../../shared/model/user.entity';
import {BookingInterpreter} from '../../shared/model/contact.entity';
import {BookingFilter} from '../../shared/model/booking-filter.interface';
import {BA, BOOKING_NATURE} from '../../shared/model/booking-nature.enum';
import {DatePipe} from '@angular/common';
import * as $ from 'jquery';
import {tap, catchError, finalize} from 'rxjs/operators';

interface ApiError<T = any> {
  errors: T[];
}

interface BookingErrorSingleId {
  booking_id: number;
  error_msg: string;
}

interface BookingErrorMultipleIds {
  booking_ids: number;
  error_msg: string;
}

@Component({
    selector: 'app-booking-list',
    templateUrl: './booking-list.component.html',
    styleUrls: ['./booking-list.component.css', './booking-list.component.scss']
})
export class BookingListComponent implements OnInit {

    @Input() bookingList: Array<Booking> = [];
    @Output() onBookingFilter = new EventEmitter();
    bookingFilter: BookingFilter = {};
    private filterParams = new URLSearchParams();
    private currentSort = {'field': 'job', 'order': 'asc'};
    @Output() onPageEmit = new EventEmitter<any>();
    @Input() p = 1;
    @Input() totalItems = 0;
    maxPaginationSize = 7;
    selectedPageNumber = 1;
    selectedPageSize = '10';
    constructor(
      public router: Router,
      private datePipe: DatePipe,
      public bookingSelector: BookingListMultiSelectService<Booking['id']>,
      private dialog: MdDialog,
      private viewContainerRef: ViewContainerRef,
      private bookingService: BookingService,
      private spinnerService: SpinnerService,
      private notificationServiceBus: NotificationServiceBus,
    ) {
      BA.loadItems();
    }

    ngOnInit() {
      if (!localStorage.getItem(GLOBAL.bookingPaginationSizeField)) {
        localStorage.setItem(GLOBAL.bookingPaginationSizeField, '10');
      }
      GLOBAL.bookingPageSize = this.selectedPageSize = localStorage.getItem(GLOBAL.bookingPaginationSizeField);

      this.filterParams = GLOBAL._filterVal;
        this.filterParams.paramsMap.forEach((value: string[], key: string) => {
            for (let v of value) {
                if (key !== 'sort' && key !== 'direction') {
                    key = key.match(/filter\[(\w+)\]/)[1];
                }
                this.bookingFilter[key] = v;
                break;
            }
        });
        if (this.filterParams.paramsMap.size === 0) {
            this.setFilterParams('start_time');
            this.bookingFilter.date_from = this.datePipe.transform(Date.now(), 'yyyy-MM-dd');
            this.bookingFilter['sort'] = 'start_time';
            this.bookingFilter['direction'] = 'asc';
        }
        this.filter('date_from', this.bookingFilter.date_from);
        this.maxPaginationSize = $(window).width() < 400 ? 5 : 7;
    }

    underScoreToSpaces(str: string) {
        if (!str) {
            return 'All';
        }
        return str.replace(/_/g, ' ');
    }

    stateToString(booking_state) {
        return Boolean(booking_state) ? this.underScoreToSpaces(BOOKING_STATE[booking_state])
            : BOOKING_STATE[BOOKING_STATE.None].toLowerCase();
    }

    isSelectedBooking(bookingID) {
        return bookingID === GLOBAL.selBookingID;
    }

    setClickedRow(booking: Booking) {
        let route;
        if (this.isCurrentUserAdminOrBookingOfficer() && this.isStateCancelClaimOrComplete(booking.state)) {
            route = 'payroll-billing';
        } else {
            route = GLOBAL.currentUser instanceof Interpreter || GLOBAL.currentUser instanceof OrganisationalRepresentative
                || GLOBAL.currentUser instanceof IndividualClient
                ? 'job-detail' : 'booking-job';
        }
        this.router.navigate(['/booking-management/' + booking.id, route]);
        GLOBAL.selBookingID = booking.id;
    }

    isStateCancelClaimOrComplete(state) {
           return state === BOOKING_STATE.Service_completed || state === BOOKING_STATE.Cancelled_chargeable ||
                  state === BOOKING_STATE.Claimed || state === BOOKING_STATE.Claimed_exported || state === BOOKING_STATE.Cancelled_claimed ||
                  state === BOOKING_STATE.Cancelled_claimed_exported;
    }

    isCurrentUser(id) {
        return GLOBAL.currentUser.id === id;
    }

    isCurrentUserAllowed() {
        return GLOBAL.currentUser instanceof Interpreter;
    }

    isCurrentUserInvitedInterpreter(interpreters) {
        // Array.includes is not there in IE
        return interpreters.filter(i => i.id === GLOBAL.currentUser.id).length > 0;
    }

    isCurrentUserAdminOrBookingOfficer(): boolean {
        return Boolean(GLOBAL.currentUser instanceof Administrator ||
            GLOBAL.currentUser instanceof BookingOfficer);
    }
    isCurrentUserInterpreter(): boolean {
        return Boolean(GLOBAL.currentUser instanceof Interpreter);
    }
    didInterpreterAccepted(interpreters: Array<BookingInterpreter>) {
        return interpreters.filter(i => i.state === 'Accepted');
    }
    isClientOrOrgRep(): boolean {
        return Boolean(GLOBAL.currentUser instanceof IndividualClient || GLOBAL.currentUser instanceof OrganisationalRepresentative);
    }

    statusList() {
        let keys = Object.keys(BOOKING_STATUS);
        return ['All', ...keys.slice(keys.length / 2)];

    }

    onPageSizeChange(pageSize) {
      GLOBAL.bookingPageSize = this.selectedPageSize = pageSize;
      this.selectedPageNumber = 1;
      localStorage.setItem(GLOBAL.bookingPaginationSizeField, pageSize);
      this.onPageEmit.emit({'page_number' : this.selectedPageNumber, 'page_size' : this.selectedPageSize});
    }
    isInterpreterStatusAccepted(booking: Booking) {
        if (this.isCurrentUserInterpreter()) {
            let r = [];
            r = booking.interpreters.filter(i => i.id === GLOBAL.currentUser.id && i.state === 'Accepted');
            return r.length;
        }
        return false;
    }
    interpreterAllowed(booking: Booking, status) {
        let res = false;
        // Green Tick => Accepted || Allocated
        // Gray => Invited , has not responded
        // Red => Invited , rejected but is not allocated
        let currentStatus = '';
        if (this.isCurrentUserInterpreter()) {
            booking.interpreters.filter(i => i.id === GLOBAL.currentUser.id)
                .map(i => currentStatus = i.state || 'Invited');

            if (currentStatus === 'Accepted' &&
                booking.state === BOOKING_STATE.In_progress) {
                res = status === 'green';

            } else if (currentStatus === 'Accepted' &&
                booking.state === BOOKING_STATE.Allocated) {
                res = status === 'green';

            } else if (currentStatus === 'Rejected' &&
                booking.state === BOOKING_STATE.In_progress) {
                res = status === 'red';


            } else if (currentStatus === 'Invited' &&
                booking.state !== BOOKING_STATE.Allocated) {
                res = status === 'gray';
            }
        }
        return res;
    }
    stateList() {
        let keys = Object.keys(BOOKING_STATE);
        keys = keys.slice(keys.length / 2);
        keys.splice(0, 1);
        return ['All', ...keys];
    }

    assignmentCategoryList() {
        let keys = Object.keys(BA.DISSCUSSION_ITEM) as Array<string>;
        return ['All', ...keys];
    }

    filterMethodType(methodType: string) {
        switch (methodType) {
            case 'onsite':
                return 'On Site';
            case 'vri':
                return 'VRI';
            default:
                return 'All';
        }
    }
    bookingMethodTypes() {
        return ['All', 'onsite', 'vri'];
    }
    bookingServiceTypes() {
        let keys = ['ASL', 'Auslan', 'BSL', 'Captioning', 'Deaf', 'Indigenous Sign', 'ISL',
            'Notetaking', 'Platform', 'Signed English', 'Tactile', 'Visual Frame'];
        return ['All', ...keys];
    }

    filterStatus() {
        if (this.bookingFilter.booking_status) {
            return this.bookingFilter.booking_status.split(',').map(status => {
                return BOOKING_STATUS[status];
            }).join(',');
        } else {
            return 'All';
        }
    }

    private formatterValueFor(field: string, value: string) {
        let formattedValue: string;
        if (value !== undefined && value.toLowerCase() === 'all') {
            return '';
        }
        if (value && value.length) {
            value = value.trim();
            value = value.replace(/,$/g, '');
            switch (field) {
                case 'booking_status':
                    formattedValue = value.split(',')
                        .filter(statusValue => BOOKING_STATUS.hasOwnProperty(statusValue))
                        .map(statusValue => BOOKING_STATUS[statusValue].toString()).join(',');
                    break;
                default:
                    formattedValue = value;
                    break;
            }
        }
        return formattedValue;
    }

    private toggleDropdownFilter(field: string, value: string) {
        const newValue = this.formatterValueFor(field, value);
        const currentValue = this.bookingFilter[field];
        const removeFilter = currentValue && currentValue.indexOf(newValue) > -1;
        if (removeFilter) {
            this.bookingFilter[field] = currentValue.replace(newValue, '').replace(/,,/g, ',').replace(/^,|,$/, '');
        } else {
            this.bookingFilter[field] = currentValue && currentValue.length ? currentValue + ',' + newValue : newValue;
        }
    }

    private unsetFilter(field: string): void {
        delete this.bookingFilter[field];
        this.filterParams.delete(`filter[${field}]`);
        GLOBAL._filterVal.delete(`filter[${field}]`);
    }

    filter(field: string, value: string, toggle?: boolean) {
        value = Boolean(value) ? value : 'all';
        if (value.toLowerCase() === 'all') {
            this.unsetFilter(field);
        } else if (toggle) {
            this.toggleDropdownFilter(field, value);
        } else {
            this.bookingFilter[field] = this.formatterValueFor(field, value);
        }
        for (let k in this.bookingFilter) {
            if (this.bookingFilter.hasOwnProperty(k)) {
                this.filterParams.set('filter[' + k + ']', this.bookingFilter[k]);
            }
        }
        GLOBAL._filterVal = this.filterParams;
        this.onBookingFilter.emit();
    }

    private isCurrentSort(field: string) {
        return this.currentSort.field === field;
    }

    private setCurrentSort(field: string) {
        let order = 'asc';
        if (this.isCurrentSort(field)) {
            order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort.field = field;
        this.currentSort.order = order;
    }

    getSortOrder(field: string) {
        return this.isCurrentSort(field) ? this.currentSort.order : '';
    }

    isDropdownItemActive(field: string, value: string): ('active'|'') {
        const formattedValue = value !== 'All' && this.formatterValueFor(field, value);
        return this.bookingFilter[field] && this.bookingFilter[field].indexOf(formattedValue) > -1 ? 'active' : '';
    }

    sort(field: string) {
        this.setFilterParams(field);
        this.onBookingFilter.emit();
    }

    setFilterParams(field: string) {
        this.setCurrentSort(field);
        this.filterParams.set('sort', this.currentSort.field);
        this.filterParams.set('direction', this.currentSort.order);
        GLOBAL._filterVal = this.filterParams;
    }

    setPage(page: number) {
        this.selectedPageNumber = page;
        this.onPageEmit.emit({'page_number' : this.selectedPageNumber, 'page_size' : this.selectedPageSize});
    }
    linkIdClicked(linkID: string) {
        this.bookingFilter.booking_ids = linkID;
        this.filter('booking_ids', this.bookingFilter.booking_ids);
    }

    calculateDaysAgo(created_at, start_time) {
        return GLOBAL.calculateDaysAgo(created_at, start_time);
    }
    to_weekDay(time) {
        return time.split(' ');
    }
    /* In AOT types are checked so need a function to do parseInt*/
    parseNumber(str) {
      return +str;
    }

    /* accept/decline functionality */

    isBookingInterpreterInvitedOrRejected(booking: Booking) {
      const interpreter = this.getBookingInterpreter(booking);
      if (!interpreter) {
        return false;
      }

      return this.isBookingInvited(booking, interpreter) || this.isBookingDeclined(booking, interpreter);
    }

    private getBookingInterpreter(booking: Booking) {
      if (!this.isCurrentUserInterpreter()) {
        return;
      }

      return booking.interpreters.find((Interpreter) => Interpreter.id === GLOBAL.currentUser.id);
    }

    private isBookingInvited(booking: Booking, interpreter: BookingInterpreter) {
      const interpreterState = interpreter.state || 'Invited';
      return interpreterState === 'Invited' && booking.state < BOOKING_STATE.Allocated;
    }

    private isBookingDeclined(booking: Booking, interpreter: BookingInterpreter) {
      return interpreter.state === 'Rejected' && booking.state === BOOKING_STATE.In_progress;
    }

    canRejectMultiple() {
      const bookingMap = (this.bookingSelector.cacheMap = this.bookingList.reduce((map, booking) => {
        map[booking.id] = booking;
        return map;
      }, this.bookingSelector.cacheMap));
      return !this.bookingSelector.selected.some((id) => {
        const booking = bookingMap[id];
        return this.isBookingDeclined(booking, this.getBookingInterpreter(booking));
      });
    }

    async acceptMultiples() {
      const result = await this.openDialog({
        title: 'Accept Multiple Bookings',
        message: `You have selected multiple bookings. Are you sure want to Accept these ${
          this.bookingSelector.count
        } highlighted bookings?`,
      });

      if (result) {
        this.spinnerService.requestInProcess(true);
        this.bookingService
          .interpreterAcceptMultiple(GLOBAL.currentUser.id, this.bookingSelector.selected)
          .pipe(
            tap(
              () => {
                this.bookingSelector.deselectAll();
                this.notificationServiceBus.launchNotification(false, 'Successfully accepted invitations');
                this.onBookingFilter.emit();
              },
              async (error: Response) => {
                if (error.status === 422) {
                  const body: ApiError<BookingErrorSingleId | BookingErrorMultipleIds> = await error.json();

                  // map duplicate booking errors
                  const bookingIdsErrorMap = body.errors.reduce(
                    (idsMap, error) => {
                      let bookingIds = idsMap[error.error_msg] || [];

                      if (error.hasOwnProperty('booking_ids')) {
                        const _error = error as BookingErrorMultipleIds;
                        bookingIds = bookingIds.concat(_error.booking_ids);
                      } else {
                        const _error = error as BookingErrorSingleId;
                        bookingIds = bookingIds.concat(_error.booking_id);
                      }
                      idsMap[error.error_msg] = bookingIds;

                      return idsMap;
                    },
                    {} as {[message: string]: number[]}
                  );

                  const errorMessages: string[] = [];
                  const errors = Object.keys(bookingIdsErrorMap);
                  const selectBookingIds = this.bookingSelector.selected.slice();
                  for (const error of errors) {
                    const bookingIds = bookingIdsErrorMap[error];

                    // exclude error ids
                    bookingIds.forEach((id) => {
                      const index = selectBookingIds.indexOf(id);
                      if (index !== -1) {
                        selectBookingIds.splice(index, 1);
                      }
                    });

                    // actual message from server: "You have a blockout at this time. Please remove the blockout before accepting the booking"
                    if (error.includes('You have a blockout at this time')) {
                      let errorMessage =
                        'Oops, you have a blockout at this time. Please check the times/dates of these bookings and deselect any bookings that conflict\n';
                      errorMessage += bookingIds.map((id) => '- ' + id).join('\n');

                      errorMessages.push(errorMessage);
                    }
                    // actual message from server: "Oops, those jobs are at the same time.
                    // Please check the times/dates of these bookings and deselect any bookings that conflict"
                    else if (error.includes('those jobs are at the same time')) {
                      const errorMessage = error + '\n' + bookingIds.map((id) => '- ' + id).join('\n');
                      errorMessages.push(errorMessage);
                    } else {
                      errorMessages.push(error);
                    }
                  }

                  if (selectBookingIds.length) {
                    // deselect successful ids
                    selectBookingIds.forEach((id) => this.bookingSelector.deselect(id));
                    // update list
                    this.onBookingFilter.emit();
                  }

                  const errorMessage = errorMessages.join('\n\n') || 'There is an error on the server side.';
                  this.notificationServiceBus.launchNotification(true, errorMessage);
                } else {
                  this.handleDefaultError(error);
                }
              }
            ),
            finalize(() => {
              this.spinnerService.requestInProcess(false);
            })
          )
          .subscribe();
      }
    }

    async rejectMultiples() {
      const result = await this.openDialog({
        title: 'Decline Multiple Bookings',
        message: `You have selected multiple bookings. Are you sure want to Decline these ${
          this.bookingSelector.count
        } highlighted bookings?`,
      });

      if (result) {
        this.bookingService
          .interpreterRejectMultiple(GLOBAL.currentUser.id, this.bookingSelector.selected)
          .pipe(
            tap(
              () => {
                this.bookingSelector.deselectAll();
                this.notificationServiceBus.launchNotification(false, 'Successfully declined invitations');
                this.onBookingFilter.emit();
              },
              (error: Response) => {
                this.handleDefaultError(error);
              }
            ),
            finalize(() => {
              this.spinnerService.requestInProcess(false);
            })
          )
          .subscribe();
      }
    }

    private async handleDefaultError(error: Response) {
      const body = await error.json();
      const errorMessage = body.errors ? body.errors.toString() : 'There is an error on the server side.';
      this.notificationServiceBus.launchNotification(true, errorMessage);
    }

    private async openDialog({
      title,
      message,
      okTitle = 'Yes',
      cancelTitle = 'No',
    }: {
      title: string;
      message: string;
      okTitle?: string;
      cancelTitle?: string;
    }) {
      const dialogRef = this.dialog.open(PopupComponent, {
        disableClose: false,
        viewContainerRef: this.viewContainerRef,
      });
      Object.assign(dialogRef.componentInstance, {title, okTitle, cancelTitle, popupMessage: message});

      const result: boolean = await dialogRef.afterClosed().toPromise();
      return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-list/booking-list.component.ts